// src/api/useFetchObjects.js
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';

const useFetchObjects = (queryKey, endpoint, token) => {
  const fetchFunction = async () => {
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const response = await axios.get(
      `${API_URL}/${endpoint}`,
      {
        headers,
      },
    );
    return response.data;
  };

  const { data, isLoading, isError, isSuccess, error, refetch } = useQuery({
    queryKey: queryKey,
    queryFn: fetchFunction,
  });

  return { data, isLoading, isError, isSuccess, error, refetch };
};

export default useFetchObjects;
